<template>
  <div class="wrapper">
    <div class="md-layout md-gutter image-text-container">
      <div
        class="md-layout-item image-text md-medium-size-50 md-small-size-100 md-xsmall-size-100 shadow"
      >
        <img :src="require('@/assets/img/' + imageOne)" alt="" />
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-small-size-100 md-xsmall-size-100 "
      >
        <p class="image-date">{{ dateOne }}</p>
        <p class="image-place">{{ placeOne }}</p>
        <h1 class="image-title">{{ nameOne }}</h1>
        <hr />
        <p class="image-content">
          {{ contentOne }}
        </p>
      </div>
    </div>

    <div class="md-layout md-gutter image-text-container ">
      <div
        class="md-layout-item md-medium-size-50 md-small-size-100 md-xsmall-size-100 image-left"
      >
        <p class="image-date">{{ dateTwo }}</p>
        <p class="image-place">{{ placeTwo }}</p>
        <h1 class="image-title">{{ nameTwo }}</h1>
        <hr />
        <p class="image-content">
          {{ contentTwo }}
        </p>
      </div>
      <div
        class="md-layout-item image-text md-medium-size-50 md-small-size-100 md-xsmall-size-100 shadow"
      >
        <img :src="require('@/assets/img/' + imageTwo)" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },

  props: {
    logo: {
      type: String,
      default: require("@/assets/img/logo-blanco-lineas.png")
    },
    header: {
      type: String,
      default: require("@/assets/img/background-default.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    },
    nameOne: String,
    nameTwo: String,
    contentOne: String,
    contentTwo: String,
    imageOne: String,
    imageTwo: String,
    dateOne: String,
    dateTwo: String,
    placeOne: String,
    placeTwo: String
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="css"></style>
